import { render, staticRenderFns } from "./DocumentBulkCreate.vue?vue&type=template&id=76863532"
import script from "./DocumentBulkCreate.vue?vue&type=script&lang=js"
export * from "./DocumentBulkCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports